import SearcherManager from "../../services/search/searcherManager";

$(function ()
{
   new SearcherManager();
});
